import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const StyledBackButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent !important;
  border: 1px solid #154cd6 !important;
  color: #154cd6 !important;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 12px;
  margin-right: auto;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(21, 76, 214, 0.07) !important;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const BackButton = ({ onClick, disabled, className }) => {
  const language = useSelector((state) => state.language);
  const isRTL = language === "ar";

  return (
    <StyledBackButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={{ flexDirection: isRTL ? "row-reverse" : "row" }}
    >
      {isRTL ? "رجوع" : "Back"}
    </StyledBackButton>
  );
};

export default BackButton;
